import { Unit } from "../types/unit";
import { createApiStore } from "./genericStore";

 
export const useUnitStore = createApiStore<Unit>("/unit");
